function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPositionMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 100 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M100,52.49c0,28.99-50,72.51-50,72.51,0,0-50-43.52-50-72.51S22.39,0,50,0s50,23.5,50,52.49Z",
    style: {
      fill: "#F9CB34"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionMapMarker);
export default __webpack_public_path__ + "static/media/position-map-marker.8bc7d4216ca24eac5d7e853023a18588.svg";
export { ForwardRef as ReactComponent };